<template>
  <div class="Others4Charts">
    <div class="test-player-wrap">
      <VuePlayerVideo class="my-video-container" :src="source2"> </VuePlayerVideo>
    </div>
  </div>
</template>

<script>
import VuePlayerVideo from 'vue3-player-video';

export default {
  name: 'Others4Charts',
  components: {
    VuePlayerVideo,
  },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      source2: 'https://en-zo.dev/vue3-player-video.mp4',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('Scaling');
        } else if (this.Configuration.isMoving) {
          console.log('Moving');
        } else {
          if (this.Configuration?.propertyData?.videoUrl?.value) {
            this.source2 = this.Configuration.propertyData.videoUrl.value;
          }
        }
      },
    },
  },
  created() {
    if (this.Configuration?.propertyData?.videoUrl?.value) {
      this.source2 = this.Configuration.propertyData.videoUrl.value;
    }
  },
  mounted() {},
  computed: {},
  methods: {},

  Configuration: {
    componentTitle: '基础视频',
    componentName: 'Others4Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others4Charts.png',
    id: '',
    style: {
      width: 462,
      height: 288,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      videoUrl: {
        value: 'https://en-zo.dev/vue3-player-video.mp4',
        lable: '视频地址',
        propertyComponentName: 'SingleInputor',
      },
      chartsColor: {
        // propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        // propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
              // 可以使用data访问api请求的响应结果        
              let seriesList = []

              let seriesListKey = 'city'
              let seriesListChildrenKey = 'casts'

              data.forEach((item) => {
                seriesList.push(item[seriesListKey])
              })
              dataSet.seriesList = seriesList
              dataSet.source = []
              data.forEach((item) => {
                item[seriesListChildrenKey].forEach(item2 => {
                  dataSet.source.push({
                    s: item[seriesListKey],
                    x: item2.date,
                    y: item2.daytemp
                  })
                })
              })
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '122',
                x: '2021-06-02 12:10:51',
              },
              {
                s: '人数',
                y: '67',
                x: '2021-06-02 11:10:51',
              },
              {
                s: '人数',
                y: '55',
                x: '2021-06-02 09:10:51',
              },
              {
                s: '人数',
                y: '34',
                x: '2021-06-02 08:10:51',
              },
              {
                s: '人数',
                y: '12',
                x: '2021-06-02 07:10:51',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        // propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        // propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others4Charts {
  color: white;
  width: 100%;
  height: 100%;
  .test-player-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
